import React, { useContext, useEffect, useState } from 'react'
import { Progress, Modal, Tag, Form, Button, Table, Input,message ,Dropdown,Menu} from 'antd'
import http from '../../../../utils/server'
import { StateContext } from '../../state';
import { Mode } from '../../../../App';
import audioSrc from '../../../../../public/assets/warning.mp3'
import headerCon1 from '../../../../../public/assets/headerCon1.png'
import headerCon2 from '../../../../../public/assets/headerCon2.png'
import headerCon3 from '../../../../../public/assets/headerCon3.png'
import headerCon4 from '../../../../../public/assets/headerCon4.png'
import headerCon5 from '../../../../../public/assets/headerCon5.png'
import headerCon1Icon from '../../../../../public/assets/headerCon1Icon.png'
import headerCon2Icon from '../../../../../public/assets/headerCon2Icon.png'
import headerCon3Icon from '../../../../../public/assets/headerCon3Icon.png'
import headerCon4Icon from '../../../../../public/assets/headerCon4Icon.png'
import headerCon5Icon from '../../../../../public/assets/headerCon5Icon.png'
import Sign from '../../sign';
import './index.less'
import { useHistory } from 'react-router-dom'
import Alarm from '../Monitor/Alarm';
function formatDateTimes(inputTime) {
  var date = new Date(inputTime);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? ('0' + m) : m;
  var d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  var h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  var minute = date.getMinutes();
  var second = date.getSeconds();
  minute = minute < 10 ? ('0' + minute) : minute;
  second = second < 10 ? ('0' + second) : second;
  return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
};
const alarmtype = [
  '设备电源断电报警',
  '设备电源恢复报警',
  '设备监测开门报警',
  '设备监测关门报警',
  '探头电源异常报警',
  '探头电源恢复正常',
  '探头监测开门报警',
  '探头监测关门报警',
  '探头连接失败报警',
  '探头连接恢复正常',
  '探头温度超标报警',
  '探头温度恢复报警',
  '探头湿度超标报警',
  '探头湿度恢复报警',
  '探头温度预警',
  '探头湿度预警',
  '探头压强超标报警',
  '探头压强恢复报警',
  '探头电量低报警',//18
  '设备离线恢复',//19
  '设备离线报警',//20
  '',//21
  '仪表传感器故障',//22
  '仪表传感器故障解除',//23
]

function DashBoard() {
  let history = useHistory();
  const [form] = Form.useForm();
  const { state, dispatch } = useContext(StateContext)
  const [Online, setOnline] = useState(0)
  const [data, setData] = useState([])

  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [showDeal, setShowDeal] = useState(false)
  const [dealList, setDealList] = useState([])
  const [showDealMsgBox, setShowDealMsgBox] = useState(false)
  const [showDealMsg, setShowDealMsg] = useState([])
  const [tableLoad,setTableLoad] =  useState(true);
  const [sginEnable,setSginEnable] = useState(false)
  const [showSgin,setShowSgin] = useState(false)
  const [mySgin,setMySgin] = useState('')
  const [sgin,setSgin] = useState('')
  const [userLogin,setUserLogin] = useState({})
  let timer;
  let interval;
  const moment = require('moment')

  function getAlarmData(){
    let audioEle = document.getElementById('audio');
    var now_date = new Date(); now_date.setHours(0); now_date.setMinutes(0); now_date.setSeconds(0);
        let url = "/v1/alarmby?" ;
        url += "starttime=" + formatDateTimes(now_date.getTime()) + "&endtime=" + formatDateTimes(new Date().getTime())
        let todo = state.main.todo;
        console.log("todoCon",todo,state);
        
        let todoCon = todo===''?null:JSON.parse(todo)
        if(todoCon&&todoCon?.showEarlyWarn){
           url+=`&earlyWarn=true` 
        }
        http.get(url,{}).then((data) => {

            setTableLoad(false)
            if (data.code === 0&&data.data!==null) {
                if(data.data.findIndex(x=>x.status===0&&(x.type%2===0||x.type===14))!==-1){
                    !state.alarmSound&&audioEle.play();
                  }
                for (var i = 0; i < data.data.length; i++) {
                    data.data[i]['key'] = i;
                }
                let tempData = data.data
                tempData.sort((a,b)=>{
                    if(a.alarm_date===b.alarm_date){
                        return b.id -a.id;
                    }else{
                       return new Date(b.alarm_date).getTime()-new Date(a.alarm_date).getTime()
                    }
                });

                setData(tempData);
            }
        })
  }

  useEffect(() => {
    http.get("/v1/devicestatus", {}).then(data => {
      if (data.code === 0 && data.data !== null&&data.data.length>0) {
        let dataF = data.data.filter(x=>x.Sensor.Hide!==1&&x.Node>0);
        var onlinep = Math.round(dataF.filter(x => { return x.Online }).length / dataF.length * 100)
        setOnline(onlinep)
        dispatch({ type: 'devicestate', devicestate: data.data })
      }
    })
    http.get("/v1/district", {}).then(data => {
      if (data.code === 0) {
        dispatch({ type: 'district', district: data.data })
      }
    })
    http.get("/v1/users", {}).then(data => {
      if (data.code === 0) {
        dispatch({ type: 'systemuser', systemuser: data.data })
        if(data.data.length>0){
          let loginuser= data.data.find(x=>x.id===state.main.id)
          setUserLogin(loginuser)
          let d = loginuser?.todo_time;
          let todo = loginuser?.todo
          let todoCon= (todo&&todo!=='')?JSON.parse(todo):null
          if(todoCon?.isNotify){
            var date = new Date(d).getTime()-new Date().getTime();
            if(date*1>0){
              parseInt(date/(1000*60*60*24))<30 &&parseInt(date/(1000*60*60*24))>0&&
              Modal.warning({
                title: '年检提醒',
                content: `即将开始年检,年检时间:${d.slice(0,10)}`,
                okText: '确认',
                cancelText: '取消',
              })
              }
            }
              
          }
          
      }
    })
    http.get("/v1/userdistricts", {}).then(data => {
      if (data.code === 0) {
        dispatch({ type: 'user_district', user_district: data.data })
      }
    })
    http.get("/v1/device", {}).then(data => {
      if (data.code === 0) {
        dispatch({ type: 'device', device: data.data })
      }
    })

    http.get("/v1/alarmsuer", {}).then(data => {
      if (data.code === 0) {
          dispatch({ type: 'alarmsuer', alarmsuer: data.data })
      }
    })
    // getAlarmData()

    // Mode==='soc'&&Modal.info({
    //   title: '更新提示',
    //   width:600,
    //   content: (
    //     <div style={{fontSize:20}}>
    //       <p>实时数据双击测点更改为查询主机多测点历史数据</p>
    //       <p>实时数据中单击参数设置或者设备编号进行参数设置</p>
    //       <p>添加报警联系人时必须要用手机扫描二维码关注公众号才能收到微信报警</p>
    //     </div>
    //   ),
    //   onOk() {},
    // });
    return () => clearInterval(timer)
  }, [])
  // useEffect(() => {
  //   clearInterval(interval);
  //   interval = setInterval(() => {
  //     getAlarmData()
  //   }, 5*60*1000)
  //   return () => clearInterval(interval)
  // }, [])
  useEffect(()=>{
    let todo = state.mainTodo;
    let todoCon = todo===''?null:JSON.parse(todo)
    if(todoCon&&todoCon.sginEnable){
        setSginEnable(true);
        setMySgin(todoCon.mySgin?todoCon.mySgin:'')
    }
},[state.mainTodo])

  return (
    <div style={{backgroundColor:'#fff',padding:'10px',height:'100%'}}>
      {
        showSgin&&<Sign getMySgin={(val)=>{
            setShowSgin(false);
            // setShowDeal(true)
            setTimeout(() => {
                if(val===mySgin){
                    setSgin(val);
                    form.submit()
                }else{
                    setSgin('');
                    Modal.error({
                        title: '错误',
                        centered: true,
                        content: '电子签名不匹配',
                    });
                }
            }, 500);
            
        }} val ={showSgin}></Sign>
    }
      <audio id="audio"  src={audioSrc} />
      <div className='HeardTitle' >
        设备数据情况
        <span style={{fontFamily:'PingFang SC',fontWeight:400,fontSize:12,color:'#666',lineHeight:'14px',marginLeft:'13px'}}>{`.截至:${moment().format('YYYY-MM-DD HH:mm')}`}</span>
      </div>
      <div style={{ display: 'flex',justifyContent:'space-around' ,marginTop:10 }}>
        <div style={{ backgroundColor:'#F1F7FF', backgroundImage:`url(${headerCon1})`}} className='heardCon'>
          <div className='heardConTop'>
            <div>
              <div className='heardConTitleText' style={{color: '#0177FB'}}> 在线比例</div>
              <div  className='heardConText' >{state.device.filter(x=>x.node!==0&&x.hide!==1&&x.type!==213).length===0?'0':Math.round(state.devicestate.filter(x => { return x.Online &&x.Node!==0&&x.Sensor.Hide!==1&&x.Type!==213 }).length / state.device.filter(x=>x.node!==0&&x.hide!==1&&x.type!==213).length * 100)}%</div>
            </div>
            <div className='heardConIcon' style={{backgroundImage:`url(${headerCon1Icon})`}}>
              {/* <Progress width={80} type="circle" strokeColor={'#1890ff'} strokeWidth={10} percent={Online} format={Online == 100 ? () => <div style={{color:'#ccc',fontSize:14}}>全部在线</div> : percent => <div style={{ color: '#1890ff' }}>{percent}%</div>} /> */}
            </div>
          </div>
          <div className='heardConBottom' style={{backgroundColor:'#A6C7F9'}}></div>
        </div>
        <div style={{ backgroundColor:'#FFF7E0', backgroundImage:`url(${headerCon2})`}} className='heardCon'>
          <div className='heardConTop'>
            <div >
              <div className='heardConTitleText' style={{ color: '#FFB300'}}> 设备总数</div>
              <div className='heardConText'>{state.device!==null&&state.device.filter(x=>x.node!==0&&x.hide!==1&&x.type!==213).length}</div>
            </div>
            <div className='heardConIcon' style={{backgroundImage:`url(${headerCon2Icon})`}}>
              {/* <Devices theme="outline" size="24" fill="#fff" /> */}
            </div>
          </div>
          <div className='heardConBottom' style={{backgroundColor:'#FFEBB3'}}></div>
        </div>
        <div style={{backgroundColor:'#FFEFE2', backgroundImage:`url(${headerCon3})`}} className='heardCon'>
          <div className='heardConTop'>
            <div>
              <div className='heardConTitleText' style={{color: '#FF7A13'}}> 在线设备</div >
              <div className='heardConText'>{state.devicestate!==null&&state.devicestate.filter(x => { return x.Online &&x.Node!==0&&x.Sensor.Hide!==1 &&x.Type!==213}).length}</div>
            </div >
            <div className='heardConIcon' style={{backgroundImage:`url(${headerCon3Icon})`}}>
              {/* <LinkOne theme="outline" size="24" fill="#fff" /> */}
            </div>
          </div>
          <div className='heardConBottom' style={{backgroundColor:'#FFD7B8'}}></div>
        </div >
        <div style={{ backgroundColor:'#DBF4EA', backgroundImage:`url(${headerCon4})`}} className='heardCon'>
          <div className='heardConTop'>
            <div>
              <div className='heardConTitleText' style={{color: '#21B97E'}}> 当日报警</div >
              <div className='heardConText'>{data}</div>
            </div >
            <div className='heardConIcon' style={{backgroundImage:`url(${headerCon4Icon})`}}>
              {/* <Alarm theme="outline" size="24" fill="#fff"/> */}
            </div>
          </div>
          <div className='heardConBottom' style={{backgroundColor:'#B6E8D4'}}></div>
        </div >
        {
          Mode==='soc'&&<div style={{ backgroundColor:'#FADEE0', backgroundImage:`url(${headerCon5})`}} className='heardCon'>
            <div className='heardConTop'>
              <div >
                <div className='heardConTitleText' style={{color: '#E75963'}}> 短信条数</div >
                <div className='heardConText'>{userLogin?.smscount&&userLogin?.smscount-userLogin.smssendcount}</div>
                {/* <div className='heardConText'>{state.main?.smscount-state.main?.smssendcount}</div> */}
              </div >
              <div className='heardConIcon' style={{backgroundImage:`url(${headerCon5Icon})`}}>
                {/* <Messages theme="outline" size="24" fill="#fff"/> */}
              </div>
            </div>
            <div className='heardConBottom' style={{backgroundColor:'#F6C3C7'}}></div>
        </div >
        }
      </div>
      <div style={{display: 'flex',justifyContent: 'space-between',alignItems: 'center',
      }}>

      </div>
        {
          <Alarm isDash={true} onValueChange={(val)=>{setData(val)} }/>
        }
    </div>
  )
}

export default DashBoard